export type Session = {
  day: string
  slots: { group: string; time: string }[]
}

export const SCHEDULE: Session[] = [
  {
    day: 'Lundi',
    slots: [
      { group: 'Enfants', time: '18h00 — 19h15' },
      { group: 'Adultes', time: '19h15 — 20h45' },
      { group: 'Perfectionnement', time: '20h45 — 21h30' },
    ],
  },
  {
    day: 'Jeudi',
    slots: [
      { group: 'Enfants', time: '18h00 — 19h15' },
      { group: 'Adultes', time: '19h15 — 21h00' },
    ],
  },
  {
    day: 'Samedi',
    slots: [{ group: 'Compétiteurs', time: '10h00 — 12h30' }],
  },
]

export const DOJO = {
  name: 'Complexe Sportif Fondada',
  address: '1423 Rte de Villeneuve-lès-Bouloc, 31620 Castelnau d’Estrétefonds',
  note: 'Dojo équipé de tatamis, vestiaires et parking gratuit. Accès à 20 min de Toulouse par l’A62 (sortie 10).',
  mapHref: 'https://www.google.com/maps/search/?api=1&query=Complexe+Sportif+Fondada+Castelnau+d%27Estr%C3%A9tefonds',
}

export type Fee = {
  group: string
  age: string
  price: string
  includes: string[]
  featured?: boolean
}

export const FEES: Fee[] = [
  {
    group: 'Enfants',
    age: '7 à 13 ans',
    price: '180 €',
    includes: ['2 cours par semaine', 'Licence FFKaraté incluse', 'Passage de grade encadré'],
  },
  {
    group: 'Adultes',
    age: '14 ans et +',
    price: '210 €',
    includes: ['2 cours par semaine', 'Licence FFKaraté incluse', 'Accès au cours perfectionnement'],
    featured: true,
  },
  {
    group: 'Compétiteurs',
    age: 'Sur sélection',
    price: '250 €',
    includes: ['Accès à tous les cours', 'Entraînement du samedi', 'Accompagnement en compétition'],
  },
]

export const ENROLMENT_STEPS = [
  {
    title: 'Venir essayer',
    text: 'Deux cours d’essai gratuits, toute l’année, sans engagement. Une simple tenue de sport suffit pour commencer.',
  },
  {
    title: 'Constituer le dossier',
    text: 'Fiche d’inscription, certificat médical ou questionnaire de santé, une photo d’identité et l’autorisation parentale pour les mineurs.',
  },
  {
    title: 'Régler la cotisation',
    text: 'Paiement en ligne via Hello Asso, en 1 à 3 fois. Coupons sport, Pass’Sport et chèques vacances acceptés.',
  },
]

export const DOCUMENTS = [
  { label: 'Fiche d’inscription 2026-2027', type: 'PDF · 180 Ko' },
  { label: 'Règlement intérieur du club', type: 'PDF · 240 Ko' },
  { label: 'Questionnaire de santé', type: 'PDF · 120 Ko' },
  { label: 'Autorisation parentale', type: 'PDF · 95 Ko' },
  { label: 'Calendrier sportif de la saison', type: 'PDF · 310 Ko' },
]
